export const GLOBAL_STATE = 'Roles'

export const ROLE = 'ROLE' as const
export const ROLE_CREATE = 'ROLE_CREATE' as const
export const ROLE_DELETE = 'ROLE_DELETE' as const
export const ROLE_LIST = 'ROLE_LIST' as const
export const ROLE_ALL = 'ROLE_LIST_ALL' as const
export const ROLE_UPDATE_USER = 'ROLE_UPDATE_USER' as const
export const ROLE_WITH_USERS = 'ROLE_WITH_USERS' as const
